// extracted by extract-css-chunks-webpack-plugin
module.exports = {"next":"next___1vqIR","prev":"prev___uja-X","arrow":"arrow___3s8Jk"};